import { WRAPPER_TOAST } from '@config/constants/toasts'

const DEFAULT_TOAST_DURATION = 10000
const DEFAULT_TOAST_ICON_PATH = '/img/toast/storm.svg'
const DEFAULT_TOAST_TYPE = 'success'

export const WRAPPER_TOAST_NAME = WRAPPER_TOAST
export const TOAST_PORTAL_NAME = 'wrapper-toast-portal-target'
export const DEFAULT_TOAST_STATE = {
  content: '',
  duration: DEFAULT_TOAST_DURATION,
  hasPortal: false,
  icon: DEFAULT_TOAST_ICON_PATH,
  isOpened: false,
  name: WRAPPER_TOAST_NAME,
  title: '',
  type: DEFAULT_TOAST_TYPE,
}
